(function() {
  var bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; };

  exports.Filter = (function() {
    function Filter(sidebar, filter) {
      var ref, ref1, ref10, ref11, ref12, ref13, ref14, ref15, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, self, years;
      if (filter == null) {
        filter = {};
      }
      this.isNotSelectedFilter = bind(this.isNotSelectedFilter, this);
      this.populateSelectedValues = bind(this.populateSelectedValues, this);
      this.populateValues = bind(this.populateValues, this);
      this.findVal = bind(this.findVal, this);
      this.unselectFilter = bind(this.unselectFilter, this);
      this.applyFilter = bind(this.applyFilter, this);
      this.selectFilter = bind(this.selectFilter, this);
      this.assignDisplayName = bind(this.assignDisplayName, this);
      this.disableFilter = bind(this.disableFilter, this);
      this.enableFilter = bind(this.enableFilter, this);
      this.handleRangeChange = bind(this.handleRangeChange, this);
      this.handleDateRangePickerChange = bind(this.handleDateRangePickerChange, this);
      self = this;
      this.sidebar = sidebar;
      this.name = (ref = filter.name) != null ? ref : '';
      this.display_name = (ref1 = filter.display_name) != null ? ref1 : '';
      this.control_type = (ref2 = filter.control_type) != null ? ref2 : 'dropdown';
      this.deletable = (ref3 = filter.deletable) != null ? ref3 : true;
      this.enable_depends = (ref4 = filter.enable_depends) != null ? ref4 : [];
      this.visible_depends = (ref5 = filter.visible_depends) != null ? ref5 : [];
      this.visible = (ref6 = filter.visible) != null ? ref6 : true;
      this.enabled = (ref7 = filter.enable) != null ? ref7 : true;
      this.refresh_on_delete = (ref8 = filter.refresh_on_delete) != null ? ref8 : true;
      this.low_range = '';
      this.high_range = '';
      this.range_min = (ref9 = filter.range_min) != null ? ref9 : 0;
      this.range_max = (ref10 = filter.range_max) != null ? ref10 : 100;
      this.daterange_format = (ref11 = filter.format) != null ? ref11 : 'YYYY-MM-DD';
      this.daterange_options = filter.options;
      this.daterange = {
        startDate: null,
        endDate: null
      };
      if (filter.years_filter != null) {
        years = this.sidebar.findInGroup(filter.years_filter);
      }
      this.daterange_year_filter = years != null ? years : null;
      this.colors = (ref12 = filter.colors) != null ? ref12 : [];
      this["class"] = (ref13 = filter["class"]) != null ? ref13 : '';
      this.values = [];
      this.displayedValues = [];
      this.selected_values = [];
      if (filter.onFilterApplied != null) {
        this.onFilterApplied = filter.onFilterApplied;
      }
      this.validateRange = (function(_this) {
        return function(range) {
          range = parseFloat(range);
          if (isNaN(range)) {
            return '';
          }
          range = Math.max(_this.range_min, range);
          range = Math.min(_this.range_max, range);
          return range;
        };
      })(this);
      this.hasOptions = (function(_this) {
        return function() {
          var i, len, ref14, ref15, v;
          if ((ref14 = _this.control_type) !== 'dropdown' && ref14 !== 'single_dropdown') {
            return true;
          }
          ref15 = _this.values;
          for (i = 0, len = ref15.length; i < len; i++) {
            v = ref15[i];
            if (v.key === null && v.value === null) {
              return false;
            }
            if (_this.findVal(v.key, _this.selected_values) == null) {
              return true;
            }
          }
          return false;
        };
      })(this);
      this.isVisible = (function(_this) {
        return function() {
          var f, i, j, len, len1, ref14, ref15, sv;
          if (!_this.visible) {
            return false;
          }
          ref14 = _this.visible_depends;
          for (i = 0, len = ref14.length; i < len; i++) {
            f = ref14[i];
            filter = _this.sidebar.findInGroup(f.name);
            if (filter) {
              ref15 = filter.selected_values;
              for (j = 0, len1 = ref15.length; j < len1; j++) {
                sv = ref15[j];
                if (sv.value !== f.selected_value) {
                  _this.selected_values = [];
                  return false;
                }
              }
            }
          }
          return true;
        };
      })(this);
      this.isEnabled = (function(_this) {
        return function() {
          var f, i, j, len, len1, ref14, ref15, sv;
          if (!_this.enabled) {
            return false;
          }
          ref14 = _this.enable_depends;
          for (i = 0, len = ref14.length; i < len; i++) {
            f = ref14[i];
            filter = _this.sidebar.findInGroup(f.name);
            if (filter) {
              ref15 = filter.selected_values;
              for (j = 0, len1 = ref15.length; j < len1; j++) {
                sv = ref15[j];
                if (sv.value !== f.selected_value) {
                  _this.selected_values = [];
                  return false;
                }
              }
            }
          }
          return _this.hasOptions();
        };
      })(this);
      this.populateValues((ref14 = filter.values) != null ? ref14 : []);
      this.populateSelectedValues((ref15 = filter.selected_values) != null ? ref15 : [], false);
    }

    Filter.prototype.handleDateRangePickerChange = function() {
      var date_range, end, start, text;
      start = this.daterange.startDate.format(this.daterange_format);
      end = this.daterange.endDate.format(this.daterange_format);
      text = start + ' to ' + end;
      date_range = {
        value: text,
        key: text
      };
      return this.selectFilter(date_range);
    };

    Filter.prototype.handleRangeChange = function() {
      var range, text;
      if (this.low_range === '' && this.high_range === '') {
        this.selected_values = [];
        return;
      } else if (this.low_range === '' && this.high_range !== '') {
        text = 'less than ' + this.high_range;
      } else if (this.low_range !== '' && this.high_range === '') {
        text = 'greater than ' + this.low_range;
      } else {
        text = this.low_range + ' to ' + this.high_range;
      }
      range = {
        value: text,
        key: text
      };
      return this.selectFilter(range);
    };

    Filter.prototype.enableFilter = function() {
      this.visible = true;
      return this.enabled = true;
    };

    Filter.prototype.disableFilter = function() {
      this.visible = false;
      return this.enabled = false;
    };

    Filter.prototype.assignDisplayName = function(name) {
      return this.display_name = name;
    };


    /*
    Fires when a value is selected in the filter list.
     */

    Filter.prototype.selectFilter = function(item) {
      return this.applyFilter(item);
    };


    /*
    This is responsible for adding the filter to the selected_values list,
    as well as setting the visible attribute false on the original item so
    it is no longer listed in the actual list of filter values
     */

    Filter.prototype.applyFilter = function(item) {
      var new_value, newitem, old_value, val;
      newitem = {
        key: item.key,
        value: item.value,
        filterColor: (function(_this) {
          return function() {
            var c;
            c = _this.findVal(item.value, _this.colors);
            if (c != null) {
              return c.color;
            } else {
              return '';
            }
          };
        })(this)
      };
      if (this.control_type === 'range') {
        this.selected_values = [];
        if ((item.key != null) && (item.value != null)) {
          val = item.key;
        }
        if (val) {
          newitem.key = val;
          newitem.value = val;
          this.selected_values.push(newitem);
        }
      }
      if (this.control_type === 'date_range') {
        this.selected_values = [];
        if ((item.key != null) && (item.value != null)) {
          val = item.key;
        }
        if (val) {
          newitem.key = val;
          newitem.value = val;
          this.selected_values.push(newitem);
        }
      } else if (this.control_type === 'dropdown') {
        if (this.findVal(item.key, this.selected_values) == null) {
          this.selected_values.push(newitem);
        }
      } else if (this.control_type === 'single_dropdown') {
        this.selected_values = [];
        this.selected_values.push(newitem);
      } else if (this.control_type === 'option') {
        if (this.selected_values.length > 0) {
          old_value = this.findVal(this.selected_values[0].key, this.values);
          if (old_value) {
            old_value.extra_class = '';
          }
          this.selected_values = [];
        }
        this.selected_values.push(newitem);
        new_value = this.findVal(item.key, this.values);
        if (new_value !== false) {
          new_value.extra_class = 'active';
        }
      }
      if (this.onFilterApplied != null) {
        return this.onFilterApplied(self, this.selected_values);
      }
    };


    /*
    Fires when a value is selected to be removed from the applied filters.
    
    This is responsible for removing the clicked item from selected_values,
    and un-hiding the value back in the actual list of filter values (if it is still in the list)
     */

    Filter.prototype.unselectFilter = function(item) {
      this.low_range = '';
      this.high_range = '';
      this.daterange = {
        startDate: null,
        endDate: null
      };
      return _.remove(this.selected_values, (function(_this) {
        return function(opt) {
          return opt === item;
        };
      })(this));
    };


    /*
    Quick utility method for finding a value in any of our arrays,
    by some kind of object key.
     */

    Filter.prototype.findVal = function(key, arr, attr) {
      var obj;
      if (attr == null) {
        attr = 'key';
      }
      if (arr != null) {
        return _.find(arr, (
          obj = {},
          obj["" + attr] = key,
          obj
        ));
      }
    };


    /*
    Ensures filter values are populated correctly
     */

    Filter.prototype.populateValues = function(vals) {
      $.each(vals, (function(_this) {
        return function(index, v) {
          if (v.value !== null) {
            v.value = v.value.toString();
            v.extra_class = '';
            return v.filterColor = function() {
              var c;
              c = _this.findVal(v.key, _this.colors);
              if (c != null) {
                return c.color;
              } else {
                return '';
              }
            };
          }
        };
      })(this));
      return this.values = vals;
    };


    /*
    Can be used to populate defaults
     */

    Filter.prototype.populateSelectedValues = function(vals, refresh) {
      var i, len, results, v;
      if (refresh == null) {
        refresh = true;
      }
      results = [];
      for (i = 0, len = vals.length; i < len; i++) {
        v = vals[i];
        results.push(this.selectFilter(v, refresh));
      }
      return results;
    };


    /*
    Check to see if given item is NOT found in the values list
    datepicker's always return false b/c they don't have a values list
     */


    /*
    Angular Filter to remove an option found in the selected values list
     */

    Filter.prototype.isNotSelectedFilter = function(item) {
      return (function(_this) {
        return function(item) {
          return _this.findVal(item.key, _this.selected_values) == null;
        };
      })(this);
    };

    return Filter;

  })();

}).call(this);
